import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getHseIncidentCalendarApi,
    getIncidentDictTreeApi,
    getIncidentByDateApi,
    getIncidentByIdApi,
    
    getIncidentDataApi,
    postIncidentCommentApi,
    putIncidentCommentApi,
    
    postIncidentDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getHseIncidentCalendarAction = createAsyncThunk(
    'HseIncidentSlice/getHseIncidentCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getHseIncidentCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getHseIncidentDictDataAction = createAsyncThunk(
    'HseIncidentSlice/getHseIncidentDictDataAction',
    async (dictType, thunkAPI) => {
        const incidentDataDict = getIncidentDictTreeApi(dictType[0]) // 单位
        const personnelDataDict = getIncidentDictTreeApi(dictType[1]) // 暴露类型
        return Promise.all([ incidentDataDict, personnelDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getHseIncidentByDateAction = createAsyncThunk(
    'HseIncidentSlice/getHseIncidentByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getIncidentByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getHseIncidentDataAction = createAsyncThunk(
    'HseIncidentSlice/getHseIncidentDataAction',
    async (id, thunkAPI) => {
        const commentData = getIncidentByIdApi(id) // 通过 id 查询
        const incidentData = getIncidentDataApi(id)
        return Promise.all([commentData, incidentData])
            .then(listData => listData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 保存数据 */
export const postHseIncidentDataAction = createAsyncThunk(
    'HseIncidentSlice/postHseIncidentDataAction',
    async ({ id, commentParams, incidentParams }, { dispatch }) => {
        let vid
        try {
            if (!id) {
                const commentData = await postIncidentCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postIncidentDataApi(incidentParams, vid)
                dispatch(HseIncidentSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putIncidentCommentApi(commentParams, id) // 修改
                
                await postIncidentDataApi(incidentParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(HseIncidentSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const HseIncidentSlice = createSlice({
    name: 'HseIncidentSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getHseIncidentCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getHseIncidentDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postHseIncidentDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getHseIncidentDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getHseIncidentByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
